import React from "react";
import {useState, useEffect} from 'react';
import Box from "@mui/material/Box";
import  Button  from '@mui/material/Button';
import { useLoginServer } from "../../../context/LoginServerContext";
import uuid from "react-uuid";
import SuccessOkDialog from "../../dialogs/SuccessOkDialog";
import { OrganizationUserData } from "../../../data/OrganizationUserData";
import OrganizationUserInformation from "./OrganizationUserInformation";
import { useAuthContext } from "../../../context/AuthContext";
import {CSVString2Array, Array2CSVString} from "../../../Utilities/Utilities";
// import crypto from 'crypto';
import { AccountData } from "../../../data/AccountData";


const alertStates = {"info":false,"warning":false,"error":false,"success":false};

// // Generate a random salt as a Uint8Array
// export function createSalt(length = 256) {
//     return crypto.randomBytes(length);
// }

// // Hash a password with a salt using SHA-512
// export function hashPassword(password, salt) {
//     const hash = crypto.createHash('sha512');
//     hash.update(salt);
//     hash.update(password);
//     return hash.digest('hex');
// }

const OrganizationUserNew = ({id, handleSave, handleClose, organizationId, permissionList}) => {

    const [row, setRow] = useState(OrganizationUserData);
    const [errorFlag, setErrorFlag] = useState(false);
    const [savedFlag, setSavedFlag] = useState(false);
    const [warningFlag, setWarningFlag] = useState(false);
    const [message, setMessage] = useState("");
    const [showDialog, setShowDialog] = useState({error:false, success:false, message:""});
    const loginServerURL = useLoginServer();
    const {currentToken} = useAuthContext();
    const [account, setAccount] = useState(AccountData);

    console.log("User New Row: ", row);



    useEffect (() => {
        //var salt = createSalt(256);
        //var hash = crypto.createHash('sha512');
        setRow({...row, organizationId:organizationId, password:"Kinetisense!123"})
    },[])

    //  useEffect(() => {
    //     const salt = createSalt(256); // 256 bytes salt
    //     const password = "Kinetisense!123";
    //     const passwordHash = hashPassword(password, salt);
    //     setAccount({
    //         id: uuid(),
    //         salt: salt.toString('hex'), // Convert Uint8Array to hex string
    //         saltedAndHashedPassword: passwordHash,
    //         saltHistory: JSON.stringify([salt.toString('hex')]), // Store salt history as a JSON string
    //         saltedAndHashedPasswordHistory: JSON.stringify([passwordHash]), // Store password history as a JSON string
    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    //     })
    // }, []);

   
    
      const handleFieldUpdate = (event, newValue, id) => {
        //console.log("Case: ",id,  newValue)
        setErrorFlag(false);
        setSavedFlag(false);
        const updatedDate = Date.UTC;
        if (id ==='name') {
            setRow({...row, name: newValue })
        } else if (id ==='username') {
            setRow({...row, username: newValue, updatedAt: updatedDate });
        } else if (id ==='name') {
            setRow({...row, name: newValue, updatedAt: updatedDate });
        } else if (id ==='middleName') {
            setRow({...row, middleName: newValue, updatedAt: updatedDate });
        } else if (id ==='surname') {
            setRow({...row, surname: newValue, updatedAt: updatedDate });
        } else if (id ==='email') {
            setRow({...row, email: newValue, username: newValue, updatedAt: updatedDate })
        } else if (id ==='phone') {
            const p = [{id:null, key:"work", value:newValue, clinicId:null, personId:null, isDeleted:false, delete:false}];
            setRow({...row, phone: newValue, updatedAt: updatedDate })
            setRow({...row, phones: p, updatedAt: updatedDate })
        } else if (id ==='roles') {
            setRow({...row, roles: Array2CSVString(newValue), updatedAt: updatedDate })
        } else if (id ==='permissions') {
            setRow({...row, permissions: Array2CSVString(newValue), updatedAt: updatedDate })
        } else if (id ==='notes') {
            setRow({...row, notes: newValue, updatedAt: updatedDate })
        } else {
            console.log("Missing: ",id)
        }
      }
      
      const accountValidation= () => {
        setWarningFlag(false);
        setMessage("")
        var flag = false;
        if (row.username === "" || row.username === null ){
            setMessage("Enter Username");
            setWarningFlag(true);
        } else if (row.email === "" || row.email === null){
            setMessage("Enter Username");
            setWarningFlag(true);
        } if (row.email.includes('@')){
            setMessage("Invalid Email address");
            setWarningFlag(true);
        }
          if (!flag) {
            flag = checkForExistingAccount(row.username);
          }
        return !flag;
      }

    const checkForExistingAccount = (username) => {
        try { 
            fetch(loginServerURL+"/api/Utilities/CheckIfAccountExists/", {
                method: 'GET',
                body: JSON.stringify(row),
                headers:{
                    "X-ZUMO-AUTH": currentToken,
                    "Content-type":"application/json"
                }
            }).then ((data) => {
                if(data.status >= 200 && data.status < 300) {
                    return data.json();
                } else {
                    return false;
                }
            }).then ((data) => {
                console.log("Check for existing account: ",data);
                if (data === true) {
                    setMessage("Account already exists");
                    setWarningFlag(true);
                    return true;
                } else {
                    return false;
                }
            }).catch ((error) => {
                console.log(error);
                return false;
            });  
        } catch(err) {
            console.log(err);
            return false;
        }
    }
    
    const handleAdd = (event) =>{
        setErrorFlag(false);
        setSavedFlag(false);
        event.preventDefault();
        if (accountValidation()) {

            console.log("Save new account: ",row)

            try { 
                fetch(loginServerURL+"/tables/OrganizationUser", {
                    method: 'POST',
                    body: JSON.stringify(row),
                    headers:{
                        "X-ZUMO-AUTH": currentToken,
                        "Content-type":"application/json"
                    }
                }).then ((data) => {
                    console.log("Accounts: ",data);
                    if(data.status >= 200 && data.status < 300) {
                        setSavedFlag(true);
                        handleSave(row);
                    } else {
                        throw new Error(data.status);
                    }
                }).catch ((error) => {
                    console.log(error);
                    setErrorFlag(true);
                });  
            } catch(err) {
                console.log(err);
                setErrorFlag(true);
            }

        }
    }

    const handleCloseDialogs = () => {
        setShowDialog({...showDialog, error:false, success:false, message:""})
    }
    


    return (
        <>
            <SuccessOkDialog open={showDialog.success} message={showDialog.message} handleClose={handleCloseDialogs}/>
          <form onSubmit={handleAdd}>
            <div className="formInput" style={{height:"630px", width:"90%"}}>
                <Box>
                    <OrganizationUserInformation 
                    data={row} 
                    title={"Account Information"} 
                    onFieldChange={(event,value, id) => handleFieldUpdate(event, value, id)}
                    permissionList={permissionList}
                    />
                </Box>
                <div className="formButtons" >
                    <div className="left">
                        {errorFlag && <div className="error">An error occured</div>}
                        {savedFlag && <div className="message">Organization User Saved</div>}
                    </div>
                    <div className = "right">
                    <Button  
                            type="button"
                            variant="contained"
                            className="button"
                            onClick={handleClose}
                            >
                            Cancel
                        </Button>
                        <Button  
                            type="submit"
                            variant="contained"
                            className="button"
                            >
                            Save
                        </Button>
                    </div>
                </div>
            </div>
        </form>
    </>
            
    );
}

export default OrganizationUserNew;